import { render, staticRenderFns } from "./ApprovalClaimList.vue?vue&type=template&id=93a774ce"
import script from "./ApprovalClaimList.vue?vue&type=script&lang=js"
export * from "./ApprovalClaimList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports